/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountingRouteImport } from './routes/accounting'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as ChartOfAccountsRouteImport } from './routes/chart-of-accounts'
import { Route as PositionsRouteImport } from './routes/positions'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StrategyRouteImport } from './routes/strategy'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as ValuationsRouteImport } from './routes/valuations'
import { Route as AssetsAssetIdRouteImport } from './routes/assets.$assetId'
import { Route as PeriodsIndexRouteImport } from './routes/periods.index'
import { Route as PeriodsPeriodIdRouteImport } from './routes/periods.$periodId'
import { Route as TransactionsIndexRouteImport } from './routes/transactions.index'
import { Route as TransactionsUnclassifiedRouteImport } from './routes/transactions.unclassified'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRoute = AccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const ChartOfAccountsRoute = ChartOfAccountsRouteImport.update({
  id: '/chart-of-accounts',
  path: '/chart-of-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const PositionsRoute = PositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyRoute = StrategyRouteImport.update({
  id: '/strategy',
  path: '/strategy',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const ValuationsRoute = ValuationsRouteImport.update({
  id: '/valuations',
  path: '/valuations',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsAssetIdRoute = AssetsAssetIdRouteImport.update({
  id: '/assets/$assetId',
  path: '/assets/$assetId',
  getParentRoute: () => rootRouteImport,
} as any)
const PeriodsIndexRoute = PeriodsIndexRouteImport.update({
  id: '/periods/',
  path: '/periods/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeriodsPeriodIdRoute = PeriodsPeriodIdRouteImport.update({
  id: '/periods/$periodId',
  path: '/periods/$periodId',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TransactionsRoute,
} as any)
const TransactionsUnclassifiedRoute =
  TransactionsUnclassifiedRouteImport.update({
    id: '/unclassified',
    path: '/unclassified',
    getParentRoute: () => TransactionsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/audit-log': typeof AuditLogRoute
  '/chart-of-accounts': typeof ChartOfAccountsRoute
  '/positions': typeof PositionsRoute
  '/settings': typeof SettingsRoute
  '/strategy': typeof StrategyRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/valuations': typeof ValuationsRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/periods/$periodId': typeof PeriodsPeriodIdRoute
  '/transactions/unclassified': typeof TransactionsUnclassifiedRoute
  '/periods/': typeof PeriodsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/audit-log': typeof AuditLogRoute
  '/chart-of-accounts': typeof ChartOfAccountsRoute
  '/positions': typeof PositionsRoute
  '/settings': typeof SettingsRoute
  '/strategy': typeof StrategyRoute
  '/valuations': typeof ValuationsRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/periods/$periodId': typeof PeriodsPeriodIdRoute
  '/transactions/unclassified': typeof TransactionsUnclassifiedRoute
  '/periods': typeof PeriodsIndexRoute
  '/transactions': typeof TransactionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/audit-log': typeof AuditLogRoute
  '/chart-of-accounts': typeof ChartOfAccountsRoute
  '/positions': typeof PositionsRoute
  '/settings': typeof SettingsRoute
  '/strategy': typeof StrategyRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/valuations': typeof ValuationsRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/periods/$periodId': typeof PeriodsPeriodIdRoute
  '/transactions/unclassified': typeof TransactionsUnclassifiedRoute
  '/periods/': typeof PeriodsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounting'
    | '/audit-log'
    | '/chart-of-accounts'
    | '/positions'
    | '/settings'
    | '/strategy'
    | '/transactions'
    | '/valuations'
    | '/assets/$assetId'
    | '/periods/$periodId'
    | '/transactions/unclassified'
    | '/periods/'
    | '/transactions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounting'
    | '/audit-log'
    | '/chart-of-accounts'
    | '/positions'
    | '/settings'
    | '/strategy'
    | '/valuations'
    | '/assets/$assetId'
    | '/periods/$periodId'
    | '/transactions/unclassified'
    | '/periods'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/accounting'
    | '/audit-log'
    | '/chart-of-accounts'
    | '/positions'
    | '/settings'
    | '/strategy'
    | '/transactions'
    | '/valuations'
    | '/assets/$assetId'
    | '/periods/$periodId'
    | '/transactions/unclassified'
    | '/periods/'
    | '/transactions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountingRoute: typeof AccountingRoute
  AuditLogRoute: typeof AuditLogRoute
  ChartOfAccountsRoute: typeof ChartOfAccountsRoute
  PositionsRoute: typeof PositionsRoute
  SettingsRoute: typeof SettingsRoute
  StrategyRoute: typeof StrategyRoute
  TransactionsRoute: typeof TransactionsRouteWithChildren
  ValuationsRoute: typeof ValuationsRoute
  AssetsAssetIdRoute: typeof AssetsAssetIdRoute
  PeriodsPeriodIdRoute: typeof PeriodsPeriodIdRoute
  PeriodsIndexRoute: typeof PeriodsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting': {
      id: '/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chart-of-accounts': {
      id: '/chart-of-accounts'
      path: '/chart-of-accounts'
      fullPath: '/chart-of-accounts'
      preLoaderRoute: typeof ChartOfAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/positions': {
      id: '/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof PositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy': {
      id: '/strategy'
      path: '/strategy'
      fullPath: '/strategy'
      preLoaderRoute: typeof StrategyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/valuations': {
      id: '/valuations'
      path: '/valuations'
      fullPath: '/valuations'
      preLoaderRoute: typeof ValuationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/$assetId': {
      id: '/assets/$assetId'
      path: '/assets/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AssetsAssetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/periods/': {
      id: '/periods/'
      path: '/periods'
      fullPath: '/periods/'
      preLoaderRoute: typeof PeriodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/periods/$periodId': {
      id: '/periods/$periodId'
      path: '/periods/$periodId'
      fullPath: '/periods/$periodId'
      preLoaderRoute: typeof PeriodsPeriodIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof TransactionsRoute
    }
    '/transactions/unclassified': {
      id: '/transactions/unclassified'
      path: '/unclassified'
      fullPath: '/transactions/unclassified'
      preLoaderRoute: typeof TransactionsUnclassifiedRouteImport
      parentRoute: typeof TransactionsRoute
    }
  }
}

interface TransactionsRouteChildren {
  TransactionsUnclassifiedRoute: typeof TransactionsUnclassifiedRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
}

const TransactionsRouteChildren: TransactionsRouteChildren = {
  TransactionsUnclassifiedRoute: TransactionsUnclassifiedRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
}

const TransactionsRouteWithChildren = TransactionsRoute._addFileChildren(
  TransactionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountingRoute: AccountingRoute,
  AuditLogRoute: AuditLogRoute,
  ChartOfAccountsRoute: ChartOfAccountsRoute,
  PositionsRoute: PositionsRoute,
  SettingsRoute: SettingsRoute,
  StrategyRoute: StrategyRoute,
  TransactionsRoute: TransactionsRouteWithChildren,
  ValuationsRoute: ValuationsRoute,
  AssetsAssetIdRoute: AssetsAssetIdRoute,
  PeriodsPeriodIdRoute: PeriodsPeriodIdRoute,
  PeriodsIndexRoute: PeriodsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
